var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.373779 7.00683C0.373779 6.65414 0.48682 6.36701 0.712901 6.14545C0.938981 5.92389 1.22837 5.81311 1.58105 5.81311H5.82686V1.5673C5.82686 1.21462 5.93312 0.925233 6.14563 0.699152C6.35814 0.473072 6.63623 0.360031 6.97987 0.360031C7.33255 0.360031 7.61967 0.473072 7.84124 0.699152C8.0628 0.925233 8.17358 1.21462 8.17358 1.5673V5.81311H12.433C12.7856 5.81311 13.0728 5.92389 13.2944 6.14545C13.5159 6.36701 13.6266 6.65414 13.6266 7.00683C13.6266 7.35047 13.5136 7.62854 13.2875 7.84106C13.0614 8.05357 12.7766 8.15983 12.433 8.15983H8.17358V12.4192C8.17358 12.7719 8.0628 13.059 7.84124 13.2806C7.61967 13.5022 7.33255 13.613 6.97987 13.613C6.63623 13.613 6.35814 13.5022 6.14563 13.2806C5.93312 13.059 5.82686 12.7719 5.82686 12.4192V8.15983H1.58105C1.22837 8.15983 0.938981 8.05357 0.712901 7.84106C0.48682 7.62854 0.373779 7.35047 0.373779 7.00683Z",
    fill: "#F9F5EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/Plus.0e5b4e6416f8b45abd0c0868c08cbbc5.svg";
export { ForwardRef as ReactComponent };